export const categories = [
  {
    id: 1,
    nameEn: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
    imageQuery: "Clean%20minimalist%20sneakers%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20modern%20European%20aesthetic%2C%20light%20beige%20backdrop%20with%20subtle%20texture%2C%20stylish%20trainer%20shoes%20isolated%20elegant%20composition",
  },
  {
    id: 2,
    nameEn: "Hoodies/Sweaters",
    namePl: "Bluzy/Swetry",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageSeq: "cat-hoodies-02",
    imageQuery: "Soft%20pastel%20hoodie%20sweater%20on%20minimal%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20cozy%20aesthetic%2C%20beige%20backdrop%20with%20soft%20shadows%2C%20modern%20European%20style%20clothing%20display",
  },
  {
    id: 3,
    nameEn: "T-Shirts",
    namePl: "Koszulki",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageSeq: "cat-tshirts-03",
    imageQuery: "Minimal%20plain%20t-shirt%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20soft%20natural%20tones%2C%20neutral%20beige%20backdrop%2C%20modern%20minimalist%20aesthetic%2C%20subtle%20fabric%20texture%20visible",
  },
  {
    id: 4,
    nameEn: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    imageSeq: "cat-jackets-04",
    imageQuery: "Stylish%20lightweight%20jacket%20on%20warm%20beige%20background%2C%20clean%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20soft%20shadows%2C%20minimal%20European%20aesthetic%2C%20neutral%20cream%20backdrop%2C%20modern%20outerwear%20display",
  },
  {
    id: 5,
    nameEn: "Pants/Shorts",
    namePl: "Spodnie/Szorty",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    imageSeq: "cat-pants-05",
    imageQuery: "Casual%20linen%20pants%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20soft%20natural%20light%2C%20modern%20minimalist%20style%2C%20neutral%20beige%20backdrop%2C%20elegant%20composition",
  },
  {
    id: 6,
    nameEn: "Headwear",
    namePl: "Nakrycia głowy",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    imageSeq: "cat-headwear-06",
    imageQuery: "Minimal%20baseball%20cap%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20modern%20European%20aesthetic%2C%20neutral%20beige%20backdrop%2C%20stylish%20headwear",
  },
  {
    id: 7,
    nameEn: "Sets",
    namePl: "Zestawy",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    imageSeq: "cat-sets-07",
    imageQuery: "Coordinated%20clothing%20set%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20soft%20natural%20light%2C%20modern%20minimalist%20style%2C%20neutral%20beige%20backdrop%2C%20matching%20outfit%20display",
  },
  {
    id: 8,
    nameEn: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    imageSeq: "cat-underwear-08",
    imageQuery: "Soft%20cotton%20underwear%20folded%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20subtle%20shadows%2C%20minimal%20European%20aesthetic%2C%20neutral%20beige%20backdrop",
  },
  {
    id: 9,
    nameEn: "Jersey",
    namePl: "Koszulki sportowe",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    imageSeq: "cat-jersey-09",
    imageQuery: "Sport%20jersey%20shirt%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20natural%20light%2C%20modern%20minimalist%20style%2C%20neutral%20beige%20backdrop",
  },
  {
    id: 10,
    nameEn: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageSeq: "cat-accessories-10",
    imageQuery: "Fashion%20accessories%20collection%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20modern%20European%20aesthetic%2C%20neutral%20beige%20backdrop%2C%20elegant%20arrangement",
  },
  {
    id: 11,
    nameEn: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    imageSeq: "cat-bags-11",
    imageQuery: "Minimal%20canvas%20tote%20bag%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20natural%20light%2C%20modern%20European%20aesthetic%2C%20neutral%20beige%20backdrop",
  },
  {
    id: 12,
    nameEn: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    imageSeq: "cat-belts-12",
    imageQuery: "Leather%20belt%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20minimal%20European%20aesthetic%2C%20neutral%20beige%20backdrop%2C%20elegant%20accessory",
  },
  {
    id: 13,
    nameEn: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    imageSeq: "cat-perfumes-13",
    imageQuery: "Elegant%20perfume%20bottle%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20natural%20light%2C%20modern%20minimalist%20style%2C%20neutral%20beige%20backdrop%2C%20luxurious%20aesthetic",
  },
  {
    id: 14,
    nameEn: "OtherStuff",
    namePl: "Inne produkty",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    imageSeq: "cat-other-14",
    imageQuery: "Various%20fashion%20items%20collection%20on%20warm%20cream%20background%2C%20clean%20studio%20lighting%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20modern%20European%20aesthetic%2C%20neutral%20beige%20backdrop%2C%20diverse%20products%20arrangement",
  },
];

export interface Category {
  id: number;
  nameEn: string;
  namePl: string;
  url: string;
  imageSeq: string;
  imageQuery: string;
}